import React from 'react';

interface LoadingProps {
    message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => {
    return (
        <div className="flex flex-col justify-center items-center min-h-[300px]">
            <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-16 w-16 mb-4"></div>
            <p className="text-gray-600 font-medium text-lg">{message}</p>
        </div>
    );
};

export default Loading;
